export const on = (
  element: Element | Document,
  event: string | string[],
  handler: (...args: any) => any,
  opts = false,
) => {
  if (Array.isArray(event)) {
    event.forEach((e) => {
      on(element, e, handler);
    });

    return;
  }

  if (element && event && handler) {
    element.addEventListener(event, handler, opts);
  }
};

export const off = (
  element: Element | Document,
  event: string | string[],
  handler: (...args: any) => any,
  opts = false,
) => {
  if (Array.isArray(event)) {
    event.forEach((e) => {
      off(element, e, handler);
    });

    return;
  }

  if (element && event) {
    element.removeEventListener(event, handler, opts);
  }
};

export const once = (
  el: Element | Document,
  event: string | string[],
  fn: (...args: any) => any,
) => {
  const listener = (...args: any) => {
    if (fn) {
      fn.apply(this, args);
    }

    off(el, event, listener);
  };

  on(el, event, listener);

  return listener;
};
